import { OutgoingMailPostingOptionDTO } from "../../models/outgoing-mail-posting-option/outgoing-mail-posting-option-dto";
import { OutgoingMailPostingOptionSTO } from "../../models/outgoing-mail-posting-option/outgoing-mail-posting-option-sto";
import { BaseApiService } from "../base";

export class OutgoingMailPostingOptionApiService extends BaseApiService<
  OutgoingMailPostingOptionDTO,
  OutgoingMailPostingOptionSTO
> {
  constructor() {
    super({
      servicePath: "/OutgoingMailPostingOption",
      loadItemsPath: "/GetOutgoingMailPostingOptions",
    });
  }
}
